import { makeStyles } from '@material-ui/core/styles';
import DehazeIcon from '@material-ui/icons/Dehaze';
import Button from '@material-ui/core/Button';
import React,{ useState,useEffect } from 'react';
import Drawer from "@material-ui/core/Drawer";
import NestedList from './NestedList';

import MainMenu from "./components/MenuComponents/MainMenu";
import "./App.css";
import Hidden from '@material-ui/core/Hidden';
import Header from './components/Header';
import CloseIcon from '@material-ui/icons/Close';
// import BoxTest from './components/breakpoints';
// import { ThemeProvider } from '@material-ui/core/styles';
// import { createMuiTheme } from '@material-ui/core/styles';
var isipad = (/CriOS/i.test(navigator.userAgent) && /ipad/i.test(navigator.userAgent)) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);

var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");


const statebtns = {
   border: "1px solid #c7c7c7",
   borderRadius: "0px",
   right: "0",
   width: "100%",
   height: '56px',
   marginLeft: "0px",
   borderLeft: "0px",
   borderRight: "0px",
   position: "fixed",
   bottom: "0px",
   marginBottom: '0px',
   backgroundColor: 'white',
   border: '1px solid #B6B6B6'
}

// const CloseBtn={
//   borderLeft: "none",
//   borderRight: "none",
//   borderRadius: "0",
//   position: "fixed",
//   background: "#fff",
//   width: "100%",
//   zIndex: "1",
// }

const useStyles = makeStyles((theme) => ({
   button: {
      margin: theme.spacing(1),
   },

   drawerPaper: {
      width: 'auto',
      width: '285px',
      overflow: 'visible',
      top: '9%'
      //background: "#c7addd"

   },

   root: {
      width: 'auto',
      /*     '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
          }, */
      //marginRight: '5vh',
      //maxWidth: 360,
      //backgroundColor: theme.palette.background.paper,
   },

   nested: {
      paddingLeft: theme.spacing(4),
   },

   formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
   },

   selectEmpty: {
      marginTop: theme.spacing(2),
   },
}));


function App() {

   const classes = useStyles();

   //States for opening Drawer
   const [state,setState] = React.useState({
      top: false,
      left: false,
      bottom: false,
      right: false,
   });

   const [burgerBtnVisible,setBurgerBtnVisible] = useState(true);

   //Open Drawer
   const toggleDrawer = (anchor,open) => (event) => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {

         return;
      }


      //Open Drawer states
      setState({ ...state,[anchor]: open });
   };
   const mobCloseDrawer = () => {
      // var currentHotspot = window.localStorage.getItem('hotspot');
      // alert(currentHotspot)
      setState({ ...state,["bottom"]: false });
      // window.playVideo = false;
      //   var tex = window.scene._Texture_ref["screen_image.jpg"];
      //   var texture = window.scene._Textures[tex.tex_id];
      //                  console.log(texture)
      //   if (texture != null) {
      //     var gl = window.scene.gl;
      //     gl.bindTexture(gl.TEXTURE_2D, texture);
      //     gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      //     gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,
      //       gl.RGBA, gl.UNSIGNED_BYTE, window.staticImage);
      //   }
      setTimeout(() => {
         document.getElementById("footerControMob").style.display = "block";
         document.getElementById("infinityrt-canvas").style.marginTop = "0px";
         document.getElementById("calloutcanvas").style.marginTop = "0px";

      },270)

      // toggleDrawer("bottom", false)
   }


   const mobOpenDrawer = () => {
      // var currentHotspot = window.localStorage.getItem('hotspot');
      // alert(currentHotspot)
      setState({ ...state,["bottom"]: true });
      // window.playVideo = false;
      //   var tex = window.scene._Texture_ref["screen_image.jpg"];
      //   var texture = window.scene._Textures[tex.tex_id];
      //                  console.log(texture)
      //   if (texture != null) {
      //     var gl = window.scene.gl;
      //     gl.bindTexture(gl.TEXTURE_2D, texture);
      //     gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      //     gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,
      //       gl.RGBA, gl.UNSIGNED_BYTE, window.staticImage);
      //   }
      document.getElementById("infinityrt-canvas").style.marginTop = "-150px";
      document.getElementById("calloutcanvas").style.marginTop = "-150px";

      document.getElementById("footerControMob").style.display = "none";
      // toggleDrawer("bottom", false)
   }

   const menuMobLandscapOpen = () => {
      setState({ ...state,["left"]: true });
      setBurgerBtnVisible(false);
      // toggleDrawer("left", true)
      // window.playVideo = false;
      //   var tex = window.scene._Texture_ref["screen_image.jpg"];
      //   var texture = window.scene._Textures[tex.tex_id];
      //                  console.log(texture)
      //   if (texture != null) {
      //     var gl = window.scene.gl;
      //     gl.bindTexture(gl.TEXTURE_2D, texture);
      //     gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      //     gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,
      //       gl.RGBA, gl.UNSIGNED_BYTE, window.staticImage);
      //   }
      if (isipad) {
         document.getElementById('footerControMob').style.zIndex = 2;
      } else if (mob) {
         document.getElementById('footerControMob').style.zIndex = 0;
         // document.getElementById("infinityrt-canvas").style.marginTop = "0px";
         // document.getElementById("calloutcanvas").style.marginTop = "0px";

      }
   }
   const menuMobLandscapClose = () => {
      setState({ ...state,["left"]: false });
      setBurgerBtnVisible(true);
      // if(isipad){
      // document.getElementById('footerControMob').style.zIndex = 2;}else if(mob){
      document.getElementById('footerControMob').style.zIndex = 2;
      // window.playVideo = false;
      // var tex = window.scene._Texture_ref["screen_image.jpg"];
      // var texture = window.scene._Textures[tex.tex_id];
      //                console.log(texture)
      // if (texture != null) {
      //   var gl = window.scene.gl;
      //   gl.bindTexture(gl.TEXTURE_2D, texture);
      //   gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      //   gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,
      //     gl.RGBA, gl.UNSIGNED_BYTE, window.staticImage);
      // }
      // document.getElementById("infinityrt-canvas").style.marginTop = "0px";
      // document.getElementById("calloutcanvas").style.marginTop = "0px";
      // }
      // toggleDrawer("left", false)
   }

   const menuDeskOpen = () => {
      setState({ ...state,["left"]: true });
      setBurgerBtnVisible(false);
      // toggleDrawer("left", true)
      if (isipad) {
         document.getElementById('footerControMob').style.zIndex = 2;
      } else if (mob) {
         document.getElementById('footerControMob').style.zIndex = 0;
         // document.getElementById("infinityrt-canvas").style.marginTop = "0px";
         // document.getElementById("calloutcanvas").style.marginTop = "0px";

      }
   }
   const menuDeskClose = () => {
      setState({ ...state,["left"]: false });
      setBurgerBtnVisible(true);
      // if(isipad){
      // document.getElementById('footerControMob').style.zIndex = 2;}else if(mob){
      document.getElementById('footerControMob').style.zIndex = 2;
      // document.getElementById("infinityrt-canvas").style.marginTop = "0px";
      // document.getElementById("calloutcanvas").style.marginTop = "0px";
      // }
      // toggleDrawer("left", false)
   }

   const [orientationPotrait,setOrientation] = useState(true);
   window.checkOrientationStatus = (orientationStatus) => {
      // alert(window.screen.orientation.type);
      setOrientation(orientationStatus);
   }
   useEffect((event) => {
      const resizeMenu = () => {
         if (window.innerWidth < 600) {
            console.log('if');
            setBurgerBtnVisible(true);
            setState({ ...state,["left"]: false });
            window.document.getElementById('footerControMob').style.display = 'block'
         }
         else if (window.innerWidth >= 601 && window.innerWidth < 1365) {
            console.log('else if');
            setBurgerBtnVisible(true);
            setState({ ...state,["left"]: false });
         }
         else if (window.innerWidth >= 1366) {
            console.log('else');
            setBurgerBtnVisible(false);
            setState({ ...state,["left"]: true });
         }
      }
      window.addEventListener('load',resizeMenu);
      window.addEventListener('resize',resizeMenu);

      return () => {
         window.removeEventListener('load',resizeMenu);
         window.removeEventListener('resize',resizeMenu);
         return false
      }

   },[])

   const [getLangTranscript,setgetLangTranscript] = useState(false);
   window.checkgetLangTranscript = (getLangTranscript) => {
      setgetLangTranscript(getLangTranscript);
   }

   let closeBtnVisibilityOpen = burgerBtnVisible && window.innerWidth > window.innerHeight;
   let closeBtnVisibilityClose = !burgerBtnVisible && window.innerWidth > window.innerHeight;
   let dektopCloseBtnVisibilityOpen = burgerBtnVisible;
   let dektopCloseBtnVisibilityClose = !burgerBtnVisible;

   const drawerClickFun = () => {
      if (window.innerWidth < 600) {
         console.log('mobCloseDrawer');
         mobCloseDrawer();
      }
      else if (window.innerWidth >= 601 && window.innerWidth < 1365) {
         console.log('menuMobLandscapClose');
         menuMobLandscapClose();
      }
      else if (window.innerWidth >= 1366) {
         console.log('menuDeskOpen');
         menuDeskOpen();
      }
   }

   let achorName = 'left';
   let toggleDrawerName = false;
   let openName = true;

   if (window.innerWidth < 600) {
      //console.log('windows less then 480.99');
      achorName = 'bottom';
      toggleDrawerName = false;
      openName = state["bottom"];
   }
   else if (window.innerWidth >= 601 && window.innerWidth < 1365) {
      //console.log('windows 481 > && < 1365');
      achorName = 'left';
      toggleDrawerName = false;
      openName = state["left"];
   }
   else if (window.innerWidth >= 1366) {

      //console.log('windows 1366');
      achorName = 'left';
      toggleDrawerName = true;
      openName = true;
   }

   return (
      <>
         {/* <Header /> */}

         <div id="menubar" className={classes.root}>
            <div id='leftPan'>

               <Drawer id="LeftMenuWrapper" anchor={achorName} open={openName} variant="persistent" onClose={toggleDrawer(achorName,toggleDrawerName)} classes={{ paper: classes.drawerPaper }}>
                  {getLangTranscript && <MainMenu className="menu-inner" toggleDrawerAction={drawerClickFun} />}
               </Drawer>

               {(window.innerWidth >= 1366) &&
                  <>
                     {/* <Drawer id="LeftMenuWrapper" anchor={"left"} open={true} variant="persistent" style={{ border: "none" }} onClose={toggleDrawer("left",true)} classes={{ paper: classes.drawerPaper }}>
                        {getLangTranscript && <MainMenu className="menu-inner" />}
                     </Drawer> */}

                     {/* {closeBtnVisibilityOpen && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuMobLandscapOpen}> </Button>} */}

                     {/* <div className="openCloseBar">
                        {dektopCloseBtnVisibilityOpen && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuDeskOpen}> </Button>}
                        {dektopCloseBtnVisibilityClose && <Button variant="outlined" color="primary" size="large" className="openCloseBtn closeBtnMobLAndscap" startIcon={<CloseIcon />} onClick={menuDeskClose} > </Button>}
                     </div> */}

                  </>
               }

               {(window.innerWidth < 600) &&
                  <>
                     {/* <Drawer anchor={"bottom"} open={state["bottom"]} variant="persistent" onClose={toggleDrawer("bottom",false)}>
                        {getLangTranscript && <MainMenu toggleDrawerAction={mobCloseDrawer} />}
                     </Drawer> */}

                     {/*  <Hidden only={['sm','md','lg','xl']}> */}
                     {/* <HeaderMob /> */}
                     <Button variant="outlined" color="primary" size="large" endIcon={<img src="./img/menu.svg" alt="menu" style={{ marginLeft: '170px',width: '23px',height: '21px' }} />} disableElevation onClick={mobOpenDrawer} style={statebtns} only='xs' >
                        <span id="mainMenu">Main Menu</span>
                     </Button>
                     {/*  </Hidden> */}
                  </>
               }

               {/* {((window.mob && window.winLandscap) || (window.isipad && window.winPortrait)) && */}
               {(window.innerWidth >= 601 && window.innerWidth < 1365) &&
                  <>
                     {/* <Drawer id="LeftMenuWrapper" anchor={"left"} open={state["left"]} variant="persistent" onClose={toggleDrawer("left",false)} classes={{ paper: classes.drawerPaper }}>
                        {getLangTranscript && <MainMenu toggleDrawerAction={menuMobLandscapClose} />}
                     </Drawer> */}

                     {/* {closeBtnVisibilityOpen && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuMobLandscapOpen}> </Button>} */}

                     <div className="openCloseBar">
                        {dektopCloseBtnVisibilityOpen && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuMobLandscapOpen}> </Button>}
                        {dektopCloseBtnVisibilityClose && <Button variant="outlined" color="primary" size="large" className="openCloseBtn closeBtnMobLAndscap" startIcon={<CloseIcon />} onClick={menuMobLandscapClose} > </Button>}
                     </div>

                     {/*  <Hidden only={['xs','lg']}>
                        {((window.mob || window.isipad)) && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuMobLandscapOpen}> </Button>}
                        {closeBtnVisibilityOpen && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuMobLandscapOpen}> </Button>}

                        {(window.mob || window.isipad) && <div className="openCloseBar"></div>}
                        {closeBtnVisibilityClose && <Button variant="outlined" color="primary" size="large" className="openCloseBtn closeBtnMobLAndscap" startIcon={<CloseIcon />} onClick={menuMobLandscapClose} > </Button>}
                     </Hidden> */}
                  </>
               }

               {/* Mobile Start */}

               {/* mobile end */}

               {/* {(window.innerWidth < window.innerHeight) && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuMobLandscapOpen}> </Button>} {(closeBtnVisibilityOpen) && <Button variant="outlined" color="primary" size="large" className="openCloseBtn" startIcon={<DehazeIcon />} disableElevation onClick={menuMobLandscapOpen}> </Button>} */}

               {/* {((window.mob || window.isipad) && (window.mobLandscap || window.isipadLandscap)) && <div className="openCloseBar"></div>}
               {(closeBtnVisibilityClose && window.mob && (window.mobPortrait || window.isipadPortrait)) && <Button variant="outlined" color="primary" size="large" className="openCloseBtn ipadClose" startIcon={<CloseIcon />} onClick={menuIpadClose} > </Button>} */}

               {/* for close mode */}

            </div>

         </div>
      </>
   );

}

export default App;